import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiRequest from "../Common/restservice";
import { errorToast, successToast } from "../Common/showtoast";
import ImageWithFallback from "../Components/ImageWithFallback";
import { FaInfo, FaTimes } from "react-icons/fa";
import { FaShield } from "react-icons/fa6";

function KYCGst() {
  const [stateObj, setStateObj] = useState({});
  const navigate = useNavigate();
  useEffect(() => {
    GetKYC();
  }, []);
  const GetKYC = async (e) => {
    let res = await ApiRequest("GetKYC_GST.asp", "GET", null, {
      Authorization: localStorage.getItem("token"),
    });
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Token Expired") {
        localStorage.clear();
        return navigate("/login");
      }
      return;
    }
    setStateObj(res);
  };
  const UploadKYC = async (e) => {
    // const gstPattern = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][A-Z0-9]{1}[Z]{1}[A-Z0-9]{1}$/;
    if (!stateObj.gstno) {
      return errorToast("Enter valid certificate number");
    } else if (!stateObj.gstcertificate) {
      return errorToast("Select valid certificate img");
    }
    const formData = new FormData();
    formData.append("profileimage", stateObj.gstcertificate);
    formData.append("GST", stateObj.gstno);
    formData.append("token", localStorage.getItem("token"));
    let res = await ApiRequest(
      "uploadgst.asp",
      "POST",
      formData,
      { Authorization: localStorage.getItem("token") },
      false
    );
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Token Expired") {
        localStorage.clear();
        return navigate("/login");
      }
      return;
    }
    successToast(res.message);
    GetKYC();
  };
  return (
    <div className="card" style={{ height: "100%" }}>
      <div className="card-header">
        <h3>Company Verification</h3>
      </div>
      <div className="card-body">
        {stateObj.KycStatus === "Waiting for Approval" && (
          <div
            className="content"
            style={{
              flexDirection: "column",
              justifyContent: "center",
              textAlign: "center",
              height:'100%',
            }}
          >
            <div>
              <button
                className="submit-btn mini btn-style-five btn btn-warning"
                style={{ borderRadius: 30, padding: "15px 20px", fontSize: 20 }}
              >
                <FaInfo />
              </button>
              <h4>
                Information has been updated. Please wait for admin to verify.
              </h4>
            </div>
          </div>
        )}
        {(stateObj.KycStatus === "Verified" || stateObj.KycStatus === "Approved") && (
          <div
            className="content"
            style={{
              flexDirection: "column",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <div>
              <button
                className="submit-btn mini btn-style-five btn btn-primary"
                style={{ borderRadius: 30, padding: "15px 20px", fontSize: 20 }}
              >
                <FaShield />
              </button>
              <h3>Company Verification Completed Successfully.</h3>
            </div>
          </div>
        )}
        {(!stateObj.KycStatus ||
          stateObj.KycStatus === "File Not Uploaded" ||
          stateObj.KycStatus === "Rejected") && (
          <div
            className="content"
            style={{ display: "flex", flexWrap: "wrap" }}
          >
            {stateObj.KycStatus === "Rejected" && (
              <div
                className="col-lg-12"
                style={{
                  flexDirection: "column",
                  justifyContent: "center",
                  textAlign: "center",
                  marginBottom: 20,
                }}
              >
                <div>
                  <button
                    className="btn btn-danger"
                    style={{
                      borderRadius: 30,
                      padding: "15px 20px !important",
                      fontSize: 20,
                    }}
                  >
                    <FaTimes />
                  </button>
                  <h3>Rejected : {stateObj.rejectmessage}</h3>
                </div>
              </div>
            )}
            <div className="col-lg-12">
              <label htmlFor="gstno">Certificate No:</label>
              <input
                onChange={(e) =>
                  setStateObj({
                    ...stateObj,
                    gstno: e.target.value.toUpperCase(),
                  })
                }
                value={stateObj.gstno}
                className="form-control"
                type="text"
                id="gstno"
                name="gstno"
                required
              />
              <div style={{ marginTop: 10 }}>
                <label>Certificate : </label>
                <br />
                <label htmlFor="gstcertificate">
                  <ImageWithFallback
                    style={{ height: 150, width: "100%" }}
                    src={stateObj.gstcertificatepreview}
                  />
                </label>
                <input
                  hidden
                  style={{ display: "none" }}
                  type="file"
                  id="gstcertificate"
                  accept="image/jpg,image/jpeg"
                  onChange={(e) => {
                    setStateObj({
                      ...stateObj,
                      gstcertificate: e.target.files[0],
                      gstcertificatepreview: URL.createObjectURL(
                        e.target.files[0]
                      ),
                    });
                  }}
                />
              </div>
            </div>
            <div
              className="btn-container"
              style={{ marginTop: 10, marginLeft: 20 }}
            >
              <button
                className="submit-btn mini btn-style-five btn btn-primary"
                onClick={() => {
                  UploadKYC();
                }}
              >
                Submit
              </button>
            </div>
          </div>
        )}
        </div>
      </div>
  );
}

export default KYCGst;
